import { render, staticRenderFns } from "./KodateContents.vue?vue&type=template&id=21515110&scoped=true&"
import script from "./KodateContents.vue?vue&type=script&lang=js&"
export * from "./KodateContents.vue?vue&type=script&lang=js&"
import style0 from "./KodateContents.vue?vue&type=style&index=0&id=21515110&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21515110",
  null
  
)

export default component.exports